
import {defineComponent} from 'vue'
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {PropType} from "vue/dist/vue";
import {UIStateDto} from "@/dtos/UIStateDto";

export default defineComponent({
  name: "PimProductsDetailCategories",
  components: {BaseDeleteButton},
  emits: ["removeDpCat"],
  props: {
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    categoryCode: {
      type: String,
      required: false
    },
    categoryPath: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    categoryTree(): string[] {
      if (this.categoryPath) {
        return this.categoryPath.split('|');
      }

      return [];
    }
  },
  methods: {
    removeDpCat(): void {
      this.$emit('removeDpCat', this.categoryCode);
    },
  },
});
